import React, { useCallback, useEffect, useState } from "react";

import {
  ChannelState,
  ChannelSubstate,
  ActionItem,
  ActionOnItem,
  getAdminActionableItems,
  getStatesForAction,
  getActionForStateAndSubState,
  ChannelActionType,
  getChannelStatusString,
  ChannelType,
} from "../../models/SKChannel";

import ActionPopup from "../../components/ActionPopup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ContainerNavigation from "../../components/ContainerNavigation";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { capitalizeFirstLetter, formatAttributeValue, getCountryName, getLanguageName } from "../../utils/stringFunctions";

import { format } from "date-fns";
import { SKChannel } from "../../models/SKChannel";
import { deleteChannel, fetchChannel, fetchReportedChannel, getChannelCounts, updateChannelStatus } from "../../api/channels/channelServices";
import ArtifactModerationDialog from "../contentModeration/ArtifactModerationDialog";
import ArtifactStateDialog, { DialoageContent } from "../artifacts/create/container/components/ArtifactStateDialog";
import APILoader from "../../components/APILoader";
import SKPagination, { PaginationObject } from "../../components/SKPagination";
import { Pagination } from "../../api/enums";
import TableHeader from "../../components/table/TableHeader";
import { useNavigationBar } from "../../context/NavigationContext";
import { useUpdateList } from "./UpdateListContext";
import { TopicTypeString } from "../../models/SKArtifact";

// const options = [
//   { title: "Request for more Information", value: "Request for more Information" },
//   { title: "Not Supported", value: "Not Supported" },
//   { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
//   { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
//   { title: "Violent or Gore", value: "Violent or Gore" },
//   { title: "Hate Speech or Discrimination", value: "Hate Speech or Discrimination" },
//   { title: "Harassment or Bullying", value: "Harassment or Bullying" },
//   { title: "Nudity or Sexual Acts", value: "Nudity or Sexual Acts" },
//   { title: "Misleading or False Information", value: "Misleading or False Information" },
//   { title: "Abusive or Exploitive", value: "Abusive or Exploitive" },
//   { title: "Spam", value: "Spam" },
//   { title: "Obscene or Explicit Language", value: "Obscene or Explicit Language" },
//   { title: "Privacy Violation", value: "Privacy Violation" },
//   { title: "Copyright Infringement or Illegal", value: "Copyright Infringement or Illegal" },
//   { title: "Other", value: "Other" },
// ];

const options_preApproval = [
  {
    title: "Request for more Information",
    value: "Request for more Information",
  },
  { title: "Not Supported", value: "Not Supported" },
  { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
  { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
  {
    title: "Misleading or False Information",
    value: "Misleading or False Information",
  },
  { title: "Spam", value: "Spam" },
  {
    title: "Obscene or Explicit Language",
    value: "Obscene or Explicit Language",
  },
  { title: "Privacy Violation", value: "Privacy Violation" },
  {
    title: "Copyright Infringement or Illegal",
    value: "Copyright Infringement or Illegal",
  },
  { title: "Other", value: "Other" },
];

const options_block = [
  { title: "Made in Error", value: "Made in Error" },
  { title: "Wrong Decision", value: "Wrong Decision" },
  { title: "Issue Addressed", value: "Issue Addressed" },
  { title: "Guideline Changed", value: "Guideline Changed" },
  { title: "Other", value: "Other" },
];

const options_normal = [
  {
    title: "Request for more Information",
    value: "Request for more Information",
  },
  { title: "Not Supported", value: "Not Supported" },
  { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
  { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
  { title: "Violent or Gore", value: "Violent or Gore" },
  {
    title: "Hate Speech or Discrimination",
    value: "Hate Speech or Discrimination",
  },
  { title: "Harassment or Bullying", value: "Harassment or Bullying" },
  { title: "Nudity or Sexual Acts", value: "Nudity or Sexual Acts" },
  {
    title: "Misleading or False Information",
    value: "Misleading or False Information",
  },
  { title: "Abusive or Exploitive", value: "Abusive or Exploitive" },
  { title: "Spam", value: "Spam" },
  {
    title: "Obscene or Explicit Language",
    value: "Obscene or Explicit Language",
  },
  { title: "Privacy Violation", value: "Privacy Violation" },
  {
    title: "Copyright Infringement or Illegal",
    value: "Copyright Infringement or Illegal",
  },
  { title: "Other", value: "Other" },
];

type SKChannelKey = keyof SKChannel;
interface ChannelTableHeader {
  key: SKChannelKey;
  label: string;
  span: number;
  sortable: boolean;
}

const ListChannels = () => {
  // const [activePopupId, setActivePopupId] = useState<number | null>(null);

  const [listCount, setListCount] = useState<Record<ChannelActionType, number>>({
    [ChannelActionType.review]: 0,
    [ChannelActionType.edit_review]: 0,
    [ChannelActionType.active]: 0,
    [ChannelActionType.withdrawn]: 0,
    [ChannelActionType.rejected]: 0,
    [ChannelActionType.flagged]: 0,
  });

  let { showChildRouteAsModal } = useNavigationBar();

  const { setUpdateListFunction } = useUpdateList();

  const [channels, setChannels] = useState<SKChannel[] | null>([]);
  const [selectedType, setSelectedType] = useState<ChannelActionType>(ChannelActionType.review);
  const [loading, setLoading] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const [options, setOptions] = useState(options_normal);
  const moderationDialogActions = [ActionItem.reject, ActionItem.delete];
  const location = useLocation();

  const [paginationObject, setPaginationObject] = useState<PaginationObject | null>(null);
  const [firstDocumentId, setFirstDocumentId] = useState<string | undefined>(undefined);
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | undefined>(undefined);

  const headers: ChannelTableHeader[] = [
    // { key: "action", label: "Action", span: 1, sortable: false }, // Non-sortable column
    { key: "name", label: "Name", span: 1, sortable: false },
    { key: "lastReportedDate", label: "Last Report", span: 1, sortable: false },
    { key: "reportCount", label: "Reports", span: 1, sortable: false },
    { key: "channelType", label: "Category", span: 1, sortable: false }, // Non-sortable column
    { key: "createdDate", label: "Submitted", span: 1, sortable: false },
    { key: "lastActivityDate", label: "Last Activity", span: 1, sortable: false },
    { key: "topic", label: "Topic", span: 1, sortable: false }, // Non-sortable column
    // { key: "age", label: "Age Rating", span: 1, sortable: false }, // Non-sortable column
    // { key: "tier", label: "Tier", span: 1, sortable: false }, // Non-sortable column
    { key: "language", label: "Primary Language", span: 1, sortable: false }, // Non-sortable column
    // { key: "secondLanguage", label: "Secondary Language", span: 1, sortable: false }, // Non-sortable column
    { key: "country", label: "Region", span: 1, sortable: false }, // Non-sortable column
    { key: "status", label: "Status", span: 1, sortable: false }, // Non-sortable column
    { key: "followerCount", label: "Followers", span: 1, sortable: false }, // Non-sortable column
    { key: "subscriberCount", label: "Subscribers", span: 1, sortable: false }, // Non-sortable column
  ];

  const getFormattedValue = (data: SKChannel, key: SKChannelKey) => {
    switch (key) {
      case "createdDate":
      case "lastReportedDate":
      case "editUpdateDate":
      case "lastActivityDate":
        return data[key] ? formatAttributeValue(data[key]) : "—";
      case "externalLinks":
        return "";
      case "status":
        return getChannelStatusString(data.status, data.subStatus);
      case "language":
        return data.language ? getLanguageName(data.language) : "—";
      case "topic":
        return data.topic ? TopicTypeString[data.topic] : "";
      case "age":
        return `Age ${data.age}+`;
      case "followerCount":
      case "subscriberCount":
      case "reportCount":
        return data[key] ?? 0;
      case "channelType":
        return data.channelType === ChannelType.brand ? "Brand" : "Creator";
      default:
        return data[key];
    }
  };

  useEffect(() => {
    showChildRouteAsModal(true);
    return () => {
      showChildRouteAsModal(false);
    };
  }, []);

  /*
   <div className="col-span-1 text-lg font-bold md:text-[11px]">Action</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Name</div>
                {selectedType === ChannelActionType.Flagged ? <div className="col-span-1 text-lg font-bold md:text-[11px]">Reason</div> : null}
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Category</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Submitted</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Topic</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Age Rating</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Tier</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Primary Language</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Secondary Language</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Region</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Status</div>
  */
  const navigate = useNavigate();
  // useEffect(() => {
  //   fetchData();
  // }, []);

  const fetchCount = async () => {
    let counts = await getChannelCounts();
    setListCount(counts);
  };

  useEffect(() => {
    fetchCount();
  }, []);

  const fetchData = async (selectedType: ChannelActionType, moveTo: Pagination) => {
    try {
      let operator = "==";
      let pageSize = 10;
      //let value = selectedType === ChannelActionType.Published ? State.published : [State.draft, State.review, State.approved, ""];
      setLoading(true);
      setChannels(null);

      let pagination: PaginationObject = {
        firstDoc: undefined,
        lastDoc: undefined,
        hasNext: false,
        hasPrev: false,
      };
      let currentDoc = undefined;

      switch (moveTo) {
        case Pagination.First:
          currentDoc = undefined;
          break;
        case Pagination.Previous:
          currentDoc = paginationObject?.firstDoc;
          break;
        case Pagination.Last:
          currentDoc = paginationObject?.lastDoc;
          switch (selectedType) {
            case ChannelActionType.review:
              pageSize = listCount["In Review"] % pageSize;
              break;
            case ChannelActionType.active:
              pageSize = listCount.Active % pageSize;
              break;
            case ChannelActionType.rejected:
              pageSize = listCount.Rejected % pageSize;
              break;
            case ChannelActionType.edit_review:
              pageSize = listCount["Edit Review"] % pageSize;
              break;
            case ChannelActionType.withdrawn:
              pageSize = listCount.Withdrawn % pageSize;
              break;
          }

          break;
        case Pagination.Next:
          currentDoc = paginationObject?.lastDoc;
          break;
      }

      switch (selectedType) {
        case ChannelActionType.review:
          const { docs: reviewedDocs, ...reviewRest } = await fetchChannel(
            ["status", "subStatus"],
            operator,
            [ChannelState.IN_REVIEW, ChannelSubstate.NONE],
            pageSize,
            currentDoc,
            false,
            moveTo,
            sortConfig
          );
          pagination = reviewRest;
          setChannels(reviewedDocs);
          break;
        case ChannelActionType.edit_review:
          const { docs: editReviewedDocs, ...editRevewRest } = await fetchChannel(
            ["status", "subStatus"],
            operator,
            [ChannelState.ACTIVE, ChannelSubstate.EDIT_IN_REVIEW],
            pageSize,
            currentDoc,
            false,
            moveTo,
            sortConfig
          );
          pagination = editRevewRest;
          setChannels(editReviewedDocs);
          break;

        case ChannelActionType.active:
          const { docs: activeDocs, ...activeRest } = await fetchChannel(
            ["status"],
            operator,
            [ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            false,
            moveTo,
            sortConfig
          );
          pagination = activeRest;
          setChannels(activeDocs);
          break;
        case ChannelActionType.withdrawn:
          const { docs: withdrawnDocs, ...withdrawnRest } = await fetchChannel(
            ["status", "subStatus"],
            operator,
            [ChannelState.DRAFT, ChannelSubstate.WITHDRAWN],
            pageSize,
            currentDoc,
            false,
            moveTo,
            sortConfig
          );
          pagination = withdrawnRest;
          setChannels(withdrawnDocs);
          break;
        case ChannelActionType.rejected:
          const { docs: rejectedDocs, ...rejectedRest } = await fetchChannel(
            ["status", "subStatus"],
            operator,
            [ChannelState.DRAFT, ChannelSubstate.REJECTED],
            pageSize,
            currentDoc,
            false,
            moveTo,
            sortConfig
          );
          pagination = rejectedRest;
          setChannels(rejectedDocs);
          break;
        case ChannelActionType.flagged:
          const { docs: flaggedDocs, ...flaggedRest } = await fetchReportedChannel(
            ["status", "subStatus"],
            [ChannelState.DRAFT, ChannelSubstate.REJECTED],
            pageSize,
            moveTo,
            currentDoc,
            sortConfig
          );
          pagination = flaggedRest;
          setChannels(flaggedDocs);
          break;
        default:
          break;
      }

      if (moveTo === Pagination.First || (pagination.firstDoc && pagination.firstDoc.id === firstDocumentId)) {
        setFirstDocumentId(pagination.firstDoc?.id);
        pagination.hasPrev = false; // Disable previous if we are on the first page
      } else if (moveTo === Pagination.Previous && pagination.firstDoc && pagination.firstDoc.id === firstDocumentId) {
        pagination.hasPrev = false; // Disable previous if we are back on the first page
      }
      setPaginationObject(pagination);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // const updateList = useCallback(
  //   (channelId: string, newState: ChannelState, newSubstate: ChannelSubstate) => {
  //     // Find the item being updated
  //     const item = channels?.find(item => item.id === channelId);

  //     if (item) {
  //       const { status: oldState, subStatus: oldSubstate } = item;

  //       // Helper function to get the corresponding ChannelActionType
  //       const getActionTypeForState = (state: ChannelState, substate: ChannelSubstate): ChannelActionType | undefined => {
  //         if (state === ChannelState.IN_REVIEW) return ChannelActionType.review;
  //         if (state === ChannelState.ACTIVE) {
  //           if (substate === ChannelSubstate.EDIT_IN_REVIEW) return ChannelActionType.edit_review;
  //           return ChannelActionType.active;
  //         }
  //         if (state === ChannelState.DRAFT) {
  //           if (substate === ChannelSubstate.REJECTED) return ChannelActionType.rejected;
  //           if (substate === ChannelSubstate.WITHDRAWN) return ChannelActionType.withdrawn;
  //         }
  //         return undefined;
  //       };

  //       // Identify the previous and new action types
  //       const previousType: ChannelActionType | undefined = getActionTypeForState(oldState, oldSubstate);
  //       const newType = getActionTypeForState(newState, newSubstate);

  //       // Update counts dynamically
  //       setListCount(prev => {
  //         const updatedCounts = { ...prev };

  //         // Decrement the count for the previous type
  //         if (previousType) {
  //           updatedCounts[previousType] -= 1;
  //           //updatedCounts[ChannelActionType.active] += 1;
  //         }

  //         // Increment the count for the new type
  //         if (newType) {
  //           updatedCounts[newType] = (updatedCounts[newType] || 0) + 1;
  //         }

  //         return updatedCounts;
  //       });

  //       // Update the local channels state
  //       setChannels(prev => {
  //         if (!prev) return null;

  //         return prev.map(existingItem =>
  //           existingItem.id === channelId ? { ...existingItem, state: newState, substate: newSubstate } : existingItem
  //         );
  //       });
  //     }

  //     // Optionally refresh data if needed
  //     fetchData(selectedType, Pagination.First);
  //   },
  //   [channels, selectedType, setChannels, setListCount]
  // );

  const updateChannelList = useCallback(
    (channelId: string, actionItem: ActionItem) => {
      // Find the channel that matches the channelId

      const item = channels?.find(channel => channel.id === channelId);

      if (item) {
        // Use the ActionItem to determine the new state and substate
        const { state: newState, substate: newSubstate } = getStatesForAction(actionItem)[0] || [];
        const oldState = item.status;
        const oldSubstate = item.subStatus;

        // Helper function to map state/substate to ChannelActionType
        const getActionTypeForState = (state: ChannelState, substate: ChannelSubstate): ChannelActionType | null => {
          if (state === ChannelState.IN_REVIEW) return ChannelActionType.review;
          if (state === ChannelState.ACTIVE) {
            if (substate === ChannelSubstate.EDIT_IN_REVIEW) return ChannelActionType.edit_review;
            return ChannelActionType.active;
          }
          if (state === ChannelState.DRAFT) {
            if (substate === ChannelSubstate.REJECTED) return ChannelActionType.rejected;
            if (substate === ChannelSubstate.WITHDRAWN) return ChannelActionType.withdrawn;
          }
          return null;
        };

        // Identify previous and new action types
        const previousType = getActionTypeForState(oldState, oldSubstate);
        const newType = getActionTypeForState(newState, newSubstate);

        // Update list count based on the action
        setListCount(prev => {
          const updatedCounts = { ...prev };

          // Decrement the count for the old action type
          if (previousType && updatedCounts[previousType] > 0) {
            updatedCounts[previousType] -= 1;
          }

          // Increment the count for the new action type
          if (newType && !(oldState === ChannelState.ACTIVE && newState === ChannelState.ACTIVE)) {
            updatedCounts[newType] = (updatedCounts[newType] || 0) + 1;
          }

          return updatedCounts;
        });

        // Update the channels state
        setChannels(prev => {
          if (!prev) return null;

          return prev.map(existingChannel =>
            existingChannel.id === channelId ? { ...existingChannel, state: newState, substate: newSubstate } : existingChannel
          );
        });
      }

      // Optionally refresh the data for the selected type
      fetchData(selectedType, Pagination.First);
    },
    [channels, selectedType, setChannels, setListCount]
  );

  useEffect(() => {
    setUpdateListFunction(() => updateChannelList);
  }, [updateChannelList, setUpdateListFunction]);

  useEffect(() => {
    fetchData(selectedType, Pagination.First);
  }, [selectedType]);

  useEffect(() => {
    setPaginationObject(null);
  }, [selectedType]);

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Channel?",
          description: "Channel and all its content will be permanently deleted form the system and cannot be recovered.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Reject Channel?",
          description: "Channel will become inactive. User can submit again.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };

      case ActionItem.deactive:
        return {
          message: "Are you sure you will like to Deactivate Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.deactive,
          destructiv: true,
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Make Inactive?",
          description: "Channel will move to inactive. User can submit again.",
          actionTitle: ActionItem.withdraw,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: " Are you sure you will like to Reject Edits?",
          description: "Channel edits will be discarded. This action cannot be undone.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };

      default:
        return null;
    }
  }

  const getPopItemsForId = (id: string): ActionItem[] => {
    let content = channels?.find(element => element.id === id);
    if (content) {
      let mixedItem = { state: content.status, subState: content.subStatus };
      return getAdminActionableItems(mixedItem);
    }
    return [];
  };

  // function getActionableItems(content: SKChannel): ActionItem[] {
  //   const actions: { [key in ChannelState]: ActionItem[] } = {
  //     draft: [],
  //     review: [ActionItem.approve, ActionItem.do_not_approve, ActionItem.block],
  //     published: [ActionItem.make_inactive, ActionItem.block],
  //     approved: [],
  //     pre_approved: [],
  //     rejected: [ActionItem.active, ActionItem.delete],
  //     need_more_info: [],
  //     blocked: [ActionItem.remove_block, ActionItem.delete],
  //     suspended: [ActionItem.remove_suspension, ActionItem.delete],
  //   };

  //   return actions[content.status] || [];
  // }

  // const updateStatus = async (contentId: string, actionItem: ActionItem, reason?: string, note?: string) => {
  //   const content = artifacts?.find(item => item.id === contentId);
  //   switch (actionItem) {
  //     case ActionItem.approve:
  //       await updateChannelStatus(contentId, content?.autoPublish ? State.published : State.approved, reason, note);
  //       // await updateArtifact(contentId, { status: content?.autoPublish ? State.published : State.approved });
  //       updateLocalStatus(contentId, content?.autoPublish ? State.published : State.approved);
  //       break;
  //     case ActionItem.do_not_approve:
  //       //await updateArtifact(contentId, { status: State.rejected });
  //       await updateChannelStatus(contentId, State.rejected, reason, note);
  //       updateLocalStatus(contentId, State.rejected);
  //       break;
  //     case ActionItem.keep_published:
  //       await updateChannel(contentId, { flaged: false });
  //       removeFlaggedItemLocally(contentId);
  //       // updateLocalStatus(contentId, State.published);
  //       break;
  //     case ActionItem.unpublish:
  //       // await updateArtifact(contentId, { status: State.draft });
  //       await updateChannelStatus(contentId, State.draft, reason, note);
  //       updateLocalStatus(contentId, State.draft);
  //       break;
  //     case ActionItem.publish:
  //       // await updateArtifact(contentId, { status: State.published });
  //       await updateChannelStatus(contentId, State.published, reason, note);
  //       updateLocalStatus(contentId, State.published);
  //       break;
  //     case ActionItem.block:
  //       // await updateArtifact(contentId, { status: State.blocked });
  //       await updateChannelStatus(contentId, State.blocked, reason, note);
  //       updateLocalStatus(contentId, State.blocked);
  //       break;
  //   }
  // };

  const removeFlaggedItemLocally = (contentId: string) => {
    let items = channels!.filter(item => item.id !== contentId);
    setChannels(items);
  };

  // const updateStatus = async (
  //   contentId: string,
  //   actionItem: ActionItem,
  //   state: ChannelState,
  //   substate: ChannelSubstate,
  //   reason?: string,
  //   note?: string
  // ) => {
  //   switch (actionItem) {
  //     case ActionItem.approve:
  //       if (state === ChannelState.IN_REVIEW && substate === ChannelSubstate.NONE) {
  //         await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE);
  //       }
  //       break;

  //     case ActionItem.do_not_approve:
  //       if (state === ChannelState.IN_REVIEW && substate === ChannelSubstate.NONE) {
  //         await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED);
  //       }
  //       break;

  //     case ActionItem.keep_published:
  //       if (state === ChannelState.ACTIVE) {
  //         await updateChannel(contentId, { flagged: false });
  //         await updateChannelHistory(contentId, actionItem);
  //         removeFlaggedItemLocally(contentId);
  //       }
  //       break;

  //     case ActionItem.make_inactive:
  //       if (state === ChannelState.ACTIVE) {
  //         await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.NONE, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.NONE);
  //       }
  //       break;

  //     case ActionItem.publish:
  //       if (state === ChannelState.ACTIVE && substate === ChannelSubstate.EDIT_IN_REVIEW) {
  //         await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE);
  //       }
  //       break;

  //     case ActionItem.suspend:
  //       if (state === ChannelState.ACTIVE) {
  //         await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED);
  //       }
  //       break;

  //     case ActionItem.remove_suspension:
  //       if (state === ChannelState.DRAFT && substate === ChannelSubstate.REJECTED) {
  //         await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE);
  //       }
  //       break;

  //     case ActionItem.block:
  //       if (state === ChannelState.ACTIVE) {
  //         await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.WITHDRAWN, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.WITHDRAWN);
  //       }
  //       break;

  //     case ActionItem.remove_block:
  //       if (state === ChannelState.DRAFT && substate === ChannelSubstate.WITHDRAWN) {
  //         await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, actionItem, reason, note);
  //         updateLocalStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE);
  //       }
  //       break;

  //     default:
  //       throw new Error(`Invalid action item: ${actionItem} for state: ${state} and substate: ${substate}`);
  //   }
  // };
  const updateStatus = async (contentId: string, actionItem: ActionItem, reason?: string, note?: string) => {
    switch (actionItem) {
      case ActionItem.approve:
        await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, reason, note);
        updateLocalStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE);
        break;
      case ActionItem.reject:
        await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED, reason, note);
        updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED);
        break;
      case ActionItem.deactive:
        await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.DEACTIVATED, reason, note);
        updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.DEACTIVATED);
        break;
      case ActionItem.withdraw:
        await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.WITHDRAWN, reason, note);
        updateLocalStatus(contentId, ChannelState.DRAFT, ChannelSubstate.WITHDRAWN);
        break;
      case ActionItem.delete:
        deleteChannel(contentId);
        deleteChannelLocally(contentId);
        // await updateChannelStatus(contentId, ChannelState.INACTIVE, ChannelSubstate.DEACTIVATED, ActionItem.withdraw, reason, note);
        // updateLocalStatus(contentId, State.published);
        break;
      default:
    }
  };

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);
  const updateLocalStatus = (contentId: string, state: ChannelState, subStatus: ChannelSubstate) => {
    let items = channels!.filter(item => {
      if (item.id === contentId) {
        var neItem = item;
        neItem.status = state;
        neItem.subStatus = subStatus;
        return neItem;
      } else {
        return item;
      }
    });

    setChannels(items);
  };

  const deleteChannelLocally = (contentId: string) => {
    let items = channels!.filter(item => item.id !== contentId);
    setChannels(items);
  };

  const showChannel = async (channelId: string) => {
    navigate("../channelDetail", { state: { channelId, backgroundLocation: location } });
  };
  // .w-button {
  //   @apply inline-block bg-[#3898EC] text-[white] leading-[inherit] no-underline cursor-pointer px-[15px] py-[9px] rounded-none border-0;
  // }

  useEffect(() => {
    fetchData(selectedType, Pagination.First);
  }, [sortConfig]);

  const handleSortChange = (config: { key: string; direction: "asc" | "desc" } | undefined) => {
    console.log("Sort Config:", config);
    setSortConfig(config);
  };

  const totalSpan = headers.reduce((sum, item) => sum + item.span, 0);
  const gridColsClass = `grid-cols-${totalSpan}`; //`grid-cols-[repeat(${totalSpan},_1fr)_auto]`;

  return (
    <div className="flex-1 bg-white">
      <div className="flex flex-col flex-1">
        {actionOnItem?.action && dialogContent ? (
          moderationDialogActions.includes(actionOnItem.action) ? (
            <ArtifactModerationDialog
              contentId={actionOnItem.itemid}
              action={actionOnItem.action}
              onAction={(contendId, action, reason, note) => {
                updateStatus(contendId, action as ActionItem, reason, note);
                setActionOnItem(null);
              }}
              onCancel={() => setActionOnItem(null)}
              options={options}
              dialogContent={dialogContent}
            />
          ) : (
            <ArtifactStateDialog
              action={actionOnItem?.action}
              onClose={() => setActionOnItem(null)}
              onUpdate={async () => {
                const action = actionOnItem?.action;
                const contentId = actionOnItem?.itemid;
                await updateStatus(contentId, action);
                setActionOnItem(null);
              }}
              dialogeContent={dialogContent}
            />
          )
        ) : (
          <></>
        )}

        <ContainerNavigation
          backArrow={false}
          title={"Channel Inbox"}
          buttonTitle={"Create"}
          subtitle={"All Channels"}
          enableLink={true}
          onSearch={() => {}}
        />

        <div className="flex flex-row gap-4 px-2  mt-[30px] overflow-x-auto">
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.review);
            }}
            className={
              (selectedType === ChannelActionType.review ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold font flex items-center dark:text-black text-nowrap"
            }
          >
            In Review . {listCount[ChannelActionType.review]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.edit_review);
            }}
            className={
              (selectedType === ChannelActionType.edit_review ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold font flex items-center dark:text-black text-nowrap"
            }
          >
            Edit Review . {listCount[ChannelActionType.edit_review]}
          </Link>

          {/* <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.Flagged);
            }}
            className={
              (selectedType === ChannelActionType.Flagged ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black"
            }
          >
            Active
          </Link> */}
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.active);
            }}
            className={
              (selectedType === ChannelActionType.active ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold font flex items-center dark:text-black text-nowrap"
            }
          >
            Active . {listCount[ChannelActionType.active]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.withdrawn);
            }}
            className={
              (selectedType === ChannelActionType.withdrawn ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Withdrawn . {listCount[ChannelActionType.withdrawn]}
          </Link>

          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.rejected);
            }}
            className={
              (selectedType === ChannelActionType.rejected ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Rejected . {listCount[ChannelActionType.rejected]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ChannelActionType.flagged);
            }}
            className={
              (selectedType === ChannelActionType.flagged ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Reported . {listCount.Flagged}
          </Link>
        </div>

        <div className="flex flex-col p-2 overflow-y-auto h-[calc(100vh-354px)]">
          {/* <div key="header" className="hidden bg-white rounded md:block ">
              <div className="grid grid-cols-12 gap-4 w-[1200px] border-b-[1px] border-gray-300 pb-3">
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Action</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Name</div>
                {selectedType === ChannelActionType.Flagged ? <div className="col-span-1 text-lg font-bold md:text-[11px]">Reason</div> : null}
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Category</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Submitted</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Topic</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Age Rating</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Tier</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Primary Language</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Secondary Language</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Region</div>
                <div className="col-span-1 text-lg font-bold md:text-[11px]">Status</div>
              </div>
            </div> */}
          <TableHeader
            headers={selectedType === ChannelActionType.flagged ? headers : headers.filter(item => item.key !== "reason")}
            onSortChange={handleSortChange}
            className={`w-full ${gridColsClass}`}
          />
          {/* id?: string;
    name?: string;
    description?: string;
    profileImageUrl?: string;
    backgroundImageUrl?: string;
    language?: string;
    secondLanguage?: string;
    country?: string;
    externalLinks: ExternalLink[] | null;
    topic: TopicType | null;
    age?: number;
    status: State;
    certifyFirst?: boolean;
    certifySecond?: boolean;
    tier: Tier;
    autoPublish?: boolean;
    createdDate?: Timestamp; */}

          {/* {loading ? <Loader /> : <></>} */}
          <div className="overflow-y-scroll ">
            <APILoader loading={loading} />

            {channels?.map(content => {
              return (
                <div
                  key={content.id}
                  className="pt-2 my-2 group hover:cursor-pointer hover:font-semibold hover:bg-skseparatorgray md:min-w-[980px]"
                  onClick={() => navigate(`${content.id}`)}
                >
                  {/* Table view for browser  */}
                  <div className="hidden md:block">
                    <div
                      key={content.id}
                      className={`grid items-center ${gridColsClass} gap-4 w-full justify-center  border-b-[1px] border-gray-300 pb-3`}
                    >
                      {/*<div className="col-span-1">
                           <ActionPopup
                            className="col-span-1 "
                            getValues={() => getPopItemsForId(content.id!)}
                            onSelect={actionItem => {
                              switch (actionItem as ActionItem) {
                                case ActionItem.approve:
                                  setOptions(options_preApproval);
                                  break;
                                case ActionItem:
                                case ActionItem.block:
                                  setOptions(options_block);
                                  break;
                                default:
                                  setOptions(options_normal);
                                  break;
                              }
                              setActionOnItem({
                                itemid: content.id!,
                                action: actionItem,
                              });
                            }}
                            align="left"
                          />
                        </div> */}
                      {headers.map(header => (
                        <div key={header.key} className={`col-span-${header.span} text-sm font-bold capitalize md:text-xs md:font-normal`}>
                          {getFormattedValue(content, header.key)}
                        </div>
                      ))}
                      {/* <div className="text-sm md:text-[14px] md:col-span-2 md:font-normal ">{content.name ?? ""}</div>

                        <div className="col-span-1 text-sm md:text-[14px] capitalize">{content.channelType}</div>
                        <div className="col-span-1 text-sm md:text-[14px]">
                          {" "}
                          {content.createdDate ? format(content.createdDate.toDate(), "MMM, dd yyyy") : "--"}
                        </div>
                        <div className="col-span-1 text-sm md:text-[14px]">{content.topic ? TopicTypeString[content.topic] : ""}</div>

                        <div className="col-span-1 text-lg font-bold md:font-normal md:text-[14px]">
                          {content.language ? getLanguageName(content.language) : ""}
                        </div>

                        <div className="col-span-1 text-lg font-bold md:font-normal md:text-[14px]">
                          {content.country ? getCountryName(content.country) : "United States"}
                        </div>
                        <div className="col-span-1 text-sm md:text-[14px]">{content.status}</div> */}
                    </div>
                  </div>

                  {/* Card view for mobile  */}
                  <div className="block md:hidden">
                    <div className="relative flex flex-col p-4 mb-4 bg-white rounded-xl border-[1px] border-skseparatorgray">
                      <div className="flex flex-row items-center justify-between">
                        <div className="flex flex-col">
                          <p className="text-gray-500">Name</p>
                          <Link
                            // to={`/channelDetail/${content.id}`}
                            to={`${content.id}`}
                            className="text-base capitalize hover:cursor-pointer"
                            state={{ backgroundLocation: location }}
                            // onClick={() => (content.id ? showChannel(content.id) : {})}
                          >
                            {content.name ?? ""}
                          </Link>
                        </div>
                        {/* <ActionPopup
                          getValues={() => getPopItemsForId(content.id!)}
                          onSelect={actionItem => {
                            switch (actionItem) {
                              case ActionItem.pre_approve:
                                setOptions(options_preApproval);
                                break;
                              case ActionItem.suspend:
                              case ActionItem.block:
                                setOptions(options_block);
                                break;
                              default:
                                setOptions(options_normal);
                                break;
                            }
                            setActionOnItem({
                              itemid: content.id!,
                              action: actionItem,
                            });
                          }}
                        /> */}
                      </div>
                      <div className="flex flex-row mt-2">
                        <div className="flex flex-col flex-1">
                          <div className="text-gray-500">Category</div>
                          <div className="text-sm capitalize">{content.channelType === ChannelType.brand ? "Brand" : "Creator"}</div>
                        </div>

                        <div className="flex flex-col flex-1">
                          <div className="text-gray-500">Region</div>
                          <div className="text-sm capitalize">{content.country}</div>
                        </div>
                      </div>
                      <div className="flex flex-row mt-2 ">
                        <div className="flex flex-col flex-1">
                          <div className="text-gray-500">Submitted</div>
                          <div className="text-sm">{content.createdDate ? format(content.createdDate.toDate(), "MMM, dd yyyy") : "--"}</div>
                        </div>
                        <div className="flex flex-col flex-1">
                          <div className="text-gray-500">Status</div>
                          <div className="text-sm capitalize">{content.status}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {(paginationObject?.hasNext || paginationObject?.hasPrev) && (
          <div className="items-center content-center mx-auto ">
            <SKPagination
              onFirst={() => {
                fetchData(selectedType, Pagination.First);
              }}
              onLast={() => {
                fetchData(selectedType, Pagination.Last);
              }}
              onNext={() => {
                fetchData(selectedType, Pagination.Next);
              }}
              onPrev={() => {
                fetchData(selectedType, Pagination.Previous);
              }}
              hasNext={paginationObject.hasNext || false}
              hasPrev={paginationObject.hasPrev || false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListChannels;
